module.exports = __webpack_public_path__ + "static/media/acompanhamentos.91873cc8.png";